var map = {
	"./symbol_0.png": "000a",
	"./symbol_1.png": "d9b7",
	"./symbol_10.png": "7a24",
	"./symbol_11.png": "c3e6",
	"./symbol_12.png": "4844",
	"./symbol_13.png": "842b",
	"./symbol_14.png": "2e52",
	"./symbol_15.png": "5bdb",
	"./symbol_16.png": "fb0b",
	"./symbol_17.png": "d818",
	"./symbol_18.png": "658a",
	"./symbol_2.png": "2304",
	"./symbol_3.png": "304d",
	"./symbol_4.png": "abf3",
	"./symbol_5.png": "835a",
	"./symbol_6.png": "6133",
	"./symbol_7.png": "2859f",
	"./symbol_8.png": "4709",
	"./symbol_9.png": "c3d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8126";